export const PERMISSIONS = {
  // Tender Permissions
  TENDER_CREATE: 'tender.create',
  TENDER_VIEW: 'tender.view', // Basic view (likely scoped by security rules/logic)
  TENDER_VIEW_CLIENT: 'tender.view_client', // View all tenders in client
  TENDER_FILES_VIEW_CLIENT: 'tender.files.view_client', // View all files in a tender (vs own only)
  TENDER_SECTIONS_VIEW_CLIENT: 'tender.sections.view_client', // View all sections in a tender (vs assigned only)
  TENDER_EDIT: 'tender.edit',
  TENDER_DELETE: 'tender.delete',
  TENDER_MANAGE_TEAM: 'tender.manage_team', // Reassign teams
  TENDER_FULL_ACCESS: 'tender.full_access', // Full access to a specific tender

  // Draft/Content Permissions
  DRAFT_CREATE: 'draft.create',
  DRAFT_EDIT: 'draft.edit',
  REVIEW_CREATE: 'review.create',
  REPORT_CREATE: 'report.create',
  INSIGHTS_VIEW: 'insights.view', // Access Analytics/Reports

  // User Management
  USER_INVITE: 'user.invite',
  USER_VIEW: 'user.view',
  USER_UPDATE: 'user.update',
  USER_DELETE: 'user.delete',
  USER_MANAGE_ROLES: 'user.manage_roles',
  USER_MANAGE_LIMITS: 'user.manage_limits',

  // Team Management
  TEAM_CREATE: 'team.create',
  TEAM_VIEW: 'team.view',
  TEAM_UPDATE: 'team.update',
  TEAM_DELETE: 'team.delete',
  TEAM_MANAGE_LIMITS: 'team.manage_limits',

  // Client/Org Management
  CLIENT_PROFILE_UPDATE: 'client.profile_update',
  CLIENT_VIEW: 'client.view',
  BILLING_MANAGE: 'billing.manage',
  SETTINGS_MANAGE: 'settings.manage',

  // Templates & Library
  TEMPLATE_VIEW_CLIENT: 'template.view_client',
  TEMPLATE_CREATE: 'template.create',
  TEMPLATE_EDIT: 'template.edit',
  TEMPLATE_DELETE: 'template.delete',
  TEMPLATE_UPLOAD_TEAM: 'template.upload_team', // Explicit team template upload
  TEMPLATE_MANAGE_CLIENT: 'template.manage_client', // Company template management
  LIBRARY_VIEW_CLIENT: 'library.view_client',
  LIBRARY_UPLOAD_TEAM: 'library.upload_team',
  LIBRARY_DELETE: 'library.delete',
  LIBRARY_MANAGE_CLIENT: 'library.manage_client',

  // Public Tenders
  PUBLIC_TENDER_VIEW: 'public_tender.view',

  // Partner Management
  PARTNER_VIEW: 'partner.view',
  PARTNER_MANAGE: 'partner.manage',

  // Support Permissions
  TICKET_CREATE: 'ticket.create',
  TICKET_VIEW: 'ticket.view',
  TICKET_UPDATE: 'ticket.update',
  TICKET_MANAGE: 'ticket.manage',

  // System (Super Admin)
  SYSTEM_MANAGE: 'system.manage',
  SYSTEM_VIEW_ALL_CLIENTS: 'system.view.all_clients',
  SYSTEM_VIEW_LOGS: 'system.view.logs',

  // Procurement Ecosystem
  PROCUREMENT_ACCESS: 'procurement.access',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
